import { render, staticRenderFns } from "./patient-list.vue?vue&type=template&id=aedd583e&scoped=true"
import script from "./patient-list.vue?vue&type=script&lang=js"
export * from "./patient-list.vue?vue&type=script&lang=js"
import style0 from "./patient-list.vue?vue&type=style&index=0&id=aedd583e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedd583e",
  null
  
)

export default component.exports